import { Stack } from '@mui/material'
import { IMilkYieldGraphItem } from 'models/IMilkYieldChartTypes'
import ChartLegend from 'ui/charts/legends/ChartLegend'
import { MILK_YIELD_LEGENDS } from '../../constants'
import YieldChart from './components/YieldChart'

interface MilkYieldChartProps {
	graph: IMilkYieldGraphItem[]
	daysBetweenDates: number
	shouldAggregateMonthly: boolean
	cowCount: number
}

export const MilkYieldChart = ({
	graph,
	daysBetweenDates,
	shouldAggregateMonthly,
	cowCount,
}: MilkYieldChartProps) => {
	return (
		<Stack direction='column' gap='16px'>
			<YieldChart
				graph={graph}
				daysBetweenDates={daysBetweenDates}
				shouldAggregateMonthly={shouldAggregateMonthly}
				cowCount={cowCount}
			/>
			<ChartLegend initialLegends={MILK_YIELD_LEGENDS} />
		</Stack>
	)
}
